// test1838
(1838 && 0);
